export class LTDataSwapRequest {
    swapKey: string; //from integration identifier key value
    latestNo: number; //add to form
    fileType: string; //for file
    loanNo: string; //for loan
    clientShortName: string; //limegear lgdataswap, identifier name value
    clientId: number; //compensafe lbadataswap, identifier name value
    dataSwapType: DataSwapType; //liverpool or london per selected client
}


export type DataSwapType = 'Liverpool' | 'London'